export const redirect = [
  //  Общие страницы
  { from: '/delivery_payment', to: '/delivery-payment' },

  // Каталог услуг
  { from: '/service_tire', to: '/service-tire' },
  { from: '/service_disk', to: '/service-disk' },
  { from: '/service_repair_tire', to: '/service-repair-tire' },
  { from: '/service_storage', to: '/service-storage' },

  {
    // eslint-disable-next-line
    from: '(?!^\/$|^\/[?].*$)(.*\/[?](.*)$|.*\/$)',
    to: (from: any, req: any) => {
      const base = req._parsedUrl.pathname.replace(/\/$/, '');
      const { search } = req._parsedUrl;
      return base + (search != null ? search : '');
    }
  }
];
